import axios from "axios"
import {getAxiosConfigWithAuth, getAccessToken} from "../../utils/auth"
import {LocalStorageHandler} from "../../utils/localStorageHandler"

const jwtDecode = require("jwt-decode")

export default class PermissionValidator {
	public async hasPermission(
		resource: string,
		resourceIdentifier: string,
		permission: string
	): Promise<boolean> {
		const permissionURI = `${encodeURIComponent(
			(jwtDecode(getAccessToken()) as any)["https://claims.cimpress.io/canonical_id"]
		)}/permissions/${resource}/${resourceIdentifier}/${permission}`
		const data = LocalStorageHandler.getData(permissionURI, true)
		if (data !== null) return data
		const uri = `https://api.cimpress.io/auth/access-management/v1/principals/${permissionURI}`
		const res = await axios
			.get(uri, getAxiosConfigWithAuth())
			.then((res) => {
				LocalStorageHandler.saveData(permissionURI, true, true)

				return true
			})
			.catch(function (e) {
				return false
			})
		return res
	}
}
